import ErrorOutlineOutlined from '@mui/icons-material/ErrorOutlineOutlined'
import styled from 'styled-components'
import { accents, brand } from 'sutra/tokens/colors'

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const MainLine = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: ${brand.stillNight[800]};
  line-height: 20px;
`

export const SubLine = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 500;
  color: rgba(40, 54, 79, 0.6);
  line-height: 18px;
`

export const BlueDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${accents.reflectionBlue[500]};
  flex-shrink: 0;
`

export const WarningIcon = styled(ErrorOutlineOutlined)`
  font-size: 15px !important;
  color: #f97066;
`

export const IncompleteTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: #f97066;
  cursor: pointer;
  /* <button> defaults to text-align: center; override so wrapped text
   * doesn't center inside the cell. */
  text-align: left;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid ${accents.reflectionBlue[500]};
    outline-offset: 2px;
    border-radius: 2px;
  }
`

export const PopoverBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const PopoverText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${brand.stillNight[800]};
`

export const RetryButton = styled.button`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #45689b;
  cursor: pointer;

  &:hover {
    color: ${accents.reflectionBlue[600]};
  }

  &:focus-visible {
    outline: 2px solid ${accents.reflectionBlue[500]};
    outline-offset: 2px;
    border-radius: 2px;
  }
`
